// @todo - should this live in a shared lib?
const EditorialStatus = {
  ADVERTISING: 'Advertising',
  EDITORIAL: 'Editorial',
  MODERATED_COMMUNITY: 'Moderated Community',
  UNMODERATED_COMMUNITY: 'Unmoderated Community',
};

module.exports = EditorialStatus;
